module.exports = __webpack_public_path__ + "public/SiteIcons/paymentTick.svg?61b17dd4";